import { format } from 'date-fns';
import * as React from 'react';
import styled from 'styled-components';
import { AgendamentoModel } from '../../../Store/Agendamento';
import { Card, CardTitle, CardContent } from '../../../Components';

interface IProps {
  agendamento: AgendamentoModel;
}

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 1rem;
  position: relative;
  margin-left: auto;
  margin-right: auto;
`;

export const AgendamentoCard: React.FC<IProps> = ({ agendamento }: IProps) =>
  <Card>
    <CardTitle>Agendamento</CardTitle>
    <CardContent>
      <Container>
        <span><b>Data de apresentação:</b> {format(agendamento.dataInicio, 'DD/MM/YYYY HH:mm')}</span>
        <span><b>Local:</b> {agendamento.local}</span>
      </Container>
    </CardContent>
  </Card>;